import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "./../../firebase";
import logo from "../../assets/img/ACT-Gray.png";

const Dashboard = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const dbRef = ref(db, "registrations");
    const unsubscribe = onValue(
      dbRef,
      (snapshot) => {
        const data = snapshot.val();

        if (data) {
          const records = Object.entries(data).map(([key, value]) => ({
            id: key,
            ...value,
          }));
          setRegistrations(records);
        } else {
          setRegistrations([]);
        }

        setLoading(false);
      },
      (error) => {
        console.error("Firebase read error:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <p className="text-center mt-5">Loading...</p>;
  }

  return (
    <div className="container-fluid mt-5">
      <div className="dashboard-header d-flex align-items-center mb-4">
        <img
          src={logo}
          alt="Company Logo"
          style={{ width: "60px", marginRight: "15px" }}
        />
        <h2 className="m-0">Registration Dashboard</h2>
      </div>
      <div
        className="table-responsive"
        style={{ maxHeight: "500px", overflowY: "auto" }}
      >
        <table className="table table-striped table-hover align-middle">
          <thead
            className="table-dark sticky-top text-dark"
            style={{ position: "sticky", top: 0, zIndex: 10 }}
          >
            <tr style={{ whiteSpace: "nowrap" }}>
              <th>#</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Title</th>
              <th>First Name</th>
              <th>Middle Name</th>
              <th>Last Name</th>
              <th>Job Title</th>
              <th>Company Website</th>
              <th>Office address</th>
              <th>City</th>
              <th>Postal Code</th>
              <th>Country</th>
              <th>Department</th>
              <th>Services</th>
              <th>Other Services</th>
              <th>T-shirt size</th>
              <th>Mobile Number</th>
              <th>Country Code</th>
              <th>Guest</th>
              <th>Diet</th>
              <th>Other Diet</th>
              <th>Food Allergy</th>
              <th>Photo Attendees</th>
              <th>Payment Total</th>
              <th>Payment status</th>
              <th>Created at</th>
            </tr>
          </thead>
          <tbody>
            {registrations.length > 0 ? (
              registrations.map((reg, index) => (
                // <tr key={reg.id}>
                //   <td>{reg.first_name}</td>
                //   <td>{reg.email}</td>
                //   <td>
                // {reg.image_url ? (
                //   <img
                //     src={reg.image_url}
                //     alt={`${reg.first_name} ${reg.last_name}`}
                //     style={{
                //       width: "50px",
                //       height: "50px",
                //       borderRadius: "50%",
                //     }}
                //   />
                // ) : (
                //   "No image"
                // )}
                //   </td>
                // </tr>
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{reg.company_name}</td>
                  <td>{reg.email}</td>
                  <td>{reg.title}</td>
                  <td>{reg.first_name}</td>
                  <td>{reg.middle_name}</td>
                  <td>{reg.last_name}</td>
                  <td>{reg.job_title}</td>
                  <td>{reg.company_website}</td>
                  <td>{reg.office_address}</td>
                  <td>{reg.city}</td>
                  <td>{reg.postal_code}</td>
                  <td>{reg.country}</td>
                  <td>{reg.department}</td>
                  <td>
                    <td>
                      {reg.service_offer?.map((item, index) => (
                        <span key={index}>
                          <span
                            style={{
                              backgroundColor: "lightgreen",
                              padding: "2px 4px",
                              borderRadius: "4px",
                              marginRight: "4px",
                            }}
                          >
                            {item}
                          </span>
                          {index < reg.service_offer.length - 1 && ", "}
                        </span>
                      ))}
                    </td>
                  </td>
                  <td>{reg.service_other}</td>
                  <td>{reg.tshirt_size}</td>
                  <td>{reg.mobile_number}</td>
                  <td>{reg.country_code}</td>
                  <td>{reg.accompanying_guest_name}</td>
                  <td>
                    {reg.dietary_restriction !== "N/A"
                      ? reg.dietary_restriction?.map((item, index) => (
                          <span
                            key={index}
                            style={{
                              backgroundColor: "lightblue",
                              padding: "2px 4px",
                              borderRadius: "4px",
                              marginRight: "4px",
                            }}
                          >
                            {item}
                          </span>
                        ))
                      : reg.dietary_restriction}
                  </td>
                  <td>{reg.dietary_others}</td>
                  <td>{reg.food_allergy}</td>
                  <td>
                    {reg.image_url ? (
                      <img
                        src={reg.image_url}
                        alt={`${reg.first_name} ${reg.last_name}`}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      "No image"
                    )}
                  </td>
                  <th>
                    {(Number(reg.registration) || 0) +
                      (Number(reg.payment_for_guest) || 0)}
                  </th>
                  <th>{reg.payment_confirm ? "true" : "false"}</th>
                  <td>
                    {new Date(reg.timestamp)
                      .toLocaleDateString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                      })
                      .replace(",", "/")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  No registrations found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Dashboard;
